import { ReactNode } from 'react';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';
import { CopyImage, CopyDescription } from './styled';

interface CopyrightLogoProps {
  title: string;
  imageUrl: string;
  description: string | ReactNode;
}

function CopyrightLogo({ title, imageUrl, description }: CopyrightLogoProps) {
  return (
    <Flex align="center" direction="column" style={{ maxWidth: '147.5px' }}>
      <CopyImage>
        <Image src={imageUrl} alt={title} />
      </CopyImage>
      <CopyDescription>{description}</CopyDescription>
    </Flex>
  );
}

export default CopyrightLogo;
